<template>
  <nav class="navbar navbar-expand-lg navbar-dark fixed-top">
    <a class="navbar-brand" href="#home">
      <img src="../assets/logo.png" />
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarTarget"
      aria-controls="navbarTarget"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarTarget">
      <div
        class="navbar-nav ml-auto"
        data-toggle="collapse"
        data-target=".navbar-collapse.show"
      >
        <a class="nav-item nav-link mx-auto" href="#home">Home</a>
        <a class="nav-item nav-link mx-auto" href="#about">About</a>
        <a class="nav-item nav-link mx-auto" href="#services">Services</a>
        <a class="nav-item nav-link mx-auto" href="#projects">Projects</a>
        <a class="nav-item nav-link mx-auto" href="#contact">Contact</a>
        <a class="nav-item nav-link mx-auto" href="tel:208-740-7130"
          >208-740-7130</a
        >
        <a
          class="fab fa-facebook-square fa-lg fa-padding"
          href="https://www.facebook.com/SKGConstruction"
          target="_blank"
        ></a>
      </div>
    </div>
  </nav>
</template>

<script>
export default {};
</script>

<style>
.navbar {
  font-weight: 600;
  font-size: 1rem;
  letter-spacing: 0.05rem;
  background: rgba(0, 0, 0, 0.5) !important;
}
.navbar-dark .navbar-nav .nav-link {
  color: white !important;
}
.navbar-dark .navbar-nav .nav-link.active,
.navbar-dark .navbar-nav .nav-link:hover {
  color: rgb(224, 45, 45) !important;
  font-weight: 600 !important;
  font-size: 1rem !important;
  letter-spacing: 0.05rem !important;
}
.fa-padding {
  padding-top: 0.8rem !important;
  padding-left: 0.6rem !important;
  padding-bottom: 0.6rem !important;
  text-align: center;
}
</style>